import React, { useContext } from "react";
import { ContentSection, Grid, GridColumn, GridRow, LabeledText } from "sprint-common-web";

import { OrderDashboardItem } from "../OrderDashboardItem";
import { OrderDashboardContext } from "../provider/OrderDashboardContext";

interface OrderMetadataSectionProps {
    minHeight: number;
}

export const OrderMetadataSection: React.VFC<OrderMetadataSectionProps> = ({
    minHeight
}: OrderMetadataSectionProps) => {
    const { orderDashboardItem, isLoading } = useContext(OrderDashboardContext);

    return (
        <ContentSection
            header="Technical metadata"
            style={{ minHeight, flex: 1 }}
            isLoading={isLoading}
            testId={"order-metadata-section"}
        >
            <Grid>
                <GridRow>
                    <GridColumn lg={6}>
                        <LabeledText
                            label="Encoding"
                            testId="order-encoding"
                            value={orderDashboardItem.metadata?.encoding}
                        />
                        <LabeledText
                            label="FFProbe aspect ratio"
                            testId="order-aspectRatio"
                            value={orderDashboardItem.metadata?.fileAspectRatio}
                        />
                        <LabeledText
                            label="Duration"
                            testId="order-duration"
                            value={orderDashboardItem.metadata?.duration}
                        />
                    </GridColumn>
                    <GridColumn lg={6}>
                        <LabeledText
                            label="Video bit rate"
                            testId="order-videoBitRate"
                            value={orderDashboardItem.metadata?.videoBitRate}
                        />
                        <LabeledText
                            label="Resolution"
                            testId="order-resolution"
                            value={getResolutionString(orderDashboardItem)}
                        />
                        <LabeledText
                            label="Framerate"
                            testId="order-framerate"
                            nowrap={false}
                            value={orderDashboardItem.metadata?.framerate}
                        />
                    </GridColumn>
                </GridRow>
            </Grid>
        </ContentSection>
    );
};

const getResolutionString = (orderDashboardItem: OrderDashboardItem): string => {
    if (!orderDashboardItem.metadata) {
        return "-";
    }

    return `${orderDashboardItem.metadata.width}x${orderDashboardItem.metadata.height}`;
};
